/* Copyright (c) 2025 MOCA Systems, Inc. All rights reserved. */

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DialogReusableModule } from 'src/app/common/dialog-reusable/dialog-reusable.module';

export interface ImagePreviewDialogData {
	imageUrl: string;
	altText?: string;
}

@Component({
	selector: 'app-image-preview-dialog',
	standalone: true,
	imports: [MatButtonModule, MatIconModule, DialogReusableModule],
	templateUrl: './image-preview-dialog.component.html',
	styleUrls: ['./image-preview-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImagePreviewDialogComponent {
	public dialogRef = inject(MatDialogRef<ImagePreviewDialogComponent>);
	public data = inject<ImagePreviewDialogData>(MAT_DIALOG_DATA);

	close(): void {
		this.dialogRef.close();
	}
}
